"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TARGET_CLS = void 0;
const TARGET_CLS = exports.TARGET_CLS = 'ant-wave-target';